module.exports = __webpack_public_path__ + "img/GENERAL-JIMNY-2.e1d79fbf.jpg";